import { type CSSProperties } from 'react';

import styles from './LinearGradientProgressBar.module.css';

export const LinearGradientProgressBar = ({ value }: { value: number }) => {
  const fillStyle = {
    '--preference-score-fill-width': `${value}%`,
  } as CSSProperties;

  return (
    <div className={styles.bar}>
      <div className={styles.fill} style={fillStyle} />
    </div>
  );
};
